// removed by extract-text-webpack-plugin
module.exports = {"xl":"size__xl___9LSJX fontSize-l height-control--xl lineHeight-control--xl","l":"size__l___HPrJ4 fontSize-m height-control--l lineHeight-control--l","m":"size__m___1uMnb fontSize-m height-control--m lineHeight-control--m","s":"size__s___3goSl fontSize-s height-control--s lineHeight-control--s","xs":"size__xs___3dZg3 fontSize-xs height-control--xs lineHeight-control--xs"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-select/UnderlinedSelect/style/size.css
// module id = 231
// module chunks = 0 8